export default __webpack_public_path__ + "static/media/WeBookPicture.71368aa9.jpg";